// Picks a logged-in customer's lines in the product hero's discount list (see
// Sonible\Pricing\DiscountTeasers for the markup) from the answer
// personal-price.js announces. Guests keep the lines the page shows them.
//
// MARKUP CONTRACT
//   <ul data-son-discount-teasers data-son-product="{product id}">
//     <li data-son-discount-teaser="sale|edu|loyalty|collection|upgrade|deals|loyalty-offer">
//
// One line for the discount the cart would apply, then the better ones still
// open: a link to the deals when loyalty beats a collection, and loyalty to someone
// who does not qualify yet. An owned product shows none. The answer's teaser for
// a product names the applied line and brings its text; a product without one
// shows its sale line, if it has one.

// Lines whose text is personal, so the page carries them empty.
const SLOTS = ['edu', 'loyalty', 'collection', 'upgrade'];

// An entry stored before the deals line carries the collection's ceiling as text.
function filledSlot(member) {
    return member && SLOTS.includes(member.source) && member.text ? member.source : null;
}

function renderList(list, entry) {
    const productId = list.dataset.sonProduct;
    const lines = {};
    list.querySelectorAll('[data-son-discount-teaser]').forEach((line) => {
        lines[line.dataset.sonDiscountTeaser] = line;
    });

    const member = entry.teasers[productId];
    const slot = filledSlot(member);
    SLOTS.forEach((kind) => {
        if (lines[kind]) {
            lines[kind].textContent = kind === slot ? member.text : '';
        }
    });

    const shown = new Set();
    if (!entry.owned.map(Number).includes(Number(productId))) {
        shown.add(slot || (lines.sale ? 'sale' : null));
        if (member && member.deals) {
            shown.add('deals');
        }
        if (entry.mode === 'none') {
            shown.add('loyalty-offer');
        }
    }

    let visible = false;
    Object.entries(lines).forEach(([kind, line]) => {
        line.hidden = !shown.has(kind);
        visible = visible || !line.hidden;
    });
    list.hidden = !visible;
}

document.addEventListener('son-personal-price', (event) => {
    document.querySelectorAll('[data-son-discount-teasers]').forEach((list) => {
        renderList(list, event.detail);
    });
});
